export default "__VITE_ASSET__BhLobI7t__"